import { useEffect, FunctionComponent } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { User, Award, Smartphone, Gift } from 'react-feather'
import Submenu from '../../components/Submenu'
import DetailOverlayPage from '../../components/DetailOverlay/Container'
import TopBar from '../../components/DetailOverlay/TopBar'
import useMembershipsStore from '../../stores/memberships'
import useAuthStore from '../../stores/auth'

const MembershipDetail: FunctionComponent = () => {
  const { getSimpleMembership, memberships } = useMembershipsStore()
  const { user } = useAuthStore()
  const { id } = useParams<{ id: string }>()

  const navigate = useNavigate()

  useEffect(() => {
    if (!id) {
      navigate('/memberships')
      return
    }

    getSimpleMembership(id)
  }, [id, getSimpleMembership, navigate])

  if (!id) {
    navigate('/memberships')
    return null
  }

  const membership = memberships[id]
  const showWalletTab = user?.organization?.appleWalletEnabled === true

  return (
    <DetailOverlayPage>
      <TopBar breadCrumbs={[
        { title: 'Memberships', linkPath: '/memberships' },
        { title: membership?.title, linkPath: '' },
      ]} closePath={'/memberships'}
      />
      {/* Publishing lives in the memberships table's row menu, alongside the
          other status transitions, rather than being split across two screens. */}
      <Submenu
        basePath={`/memberships/${id}`}
        items={[
          {
            id: 'subscriptions',
            icon: User,
            title: 'Subscriptions',
            subPath: ''
          },
          {
            id: 'benefits',
            icon: Award,
            title: 'Benefits',
            subPath: '/benefits'
          },
          // Wallet tab visible to admin/super_admin when org has Apple Wallet enabled
          ...(showWalletTab ? [{
            id: 'wallet',
            icon: Smartphone,
            title: 'Wallet',
            subPath: '/wallet'
          }] : []),
          {
            id: 'gift-cards',
            icon: Gift,
            title: 'Gift Cards',
            subPath: '/gift-cards'
          },
        ]}
      />
    </DetailOverlayPage>
  )
}

export default MembershipDetail
